import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate, NavLink } from "react-router-dom";
import Layout, { PixelStyle } from "../../components/layout";
import { HeaderContainer } from "./viewreport";
import { ref, get, set } from "firebase/database";
import { database } from "../../config/config";
import { MdOutlineAdd } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import DocumentTableTemplate from "../../components/documentTableTemplate";
import TabularTableTamplate from "../../components/tabularTableTamplate";
import { document, tabularTableIcon } from "../../assets";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { RiDeleteBin6Line } from "react-icons/ri";
import { SearchableDropdown } from "../../components/reportComponents";
import Modal from "../../components/Modal";
import { GetAllTourAPI, GetTourByIdAPI } from "../../apis/tour";
import EmailSection from "../../components/EmailInput";
import ExportConfig from "../../components/ExportConfig";

import {
  TableComponent,
  TablePreview,
  TabularTableComponent,
  TabularTablePreview,
} from "./tableComponents";
import { API_URL } from "../../apis/apiurl";
import { useAppContext } from "../../context/appContext";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { uploadExcelDataAPI, upsertExcelDataAPI, getExcelDataByReportAPI, deleteExcelDataByReportAPI } from "../../apis/excelData";

const ReportCustomize = () => {
  const { reportTempId } = useParams();
  const { setPopupMessage } = useAppContext();

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [chooseTable, setChooseTable] = useState(false);
  const [docTableName, setDocTableName] = useState(`table 1`);
  const [TabuTableName, setTabuTableName] = useState(`table 1`);
  const [documentTableData, setDocumentTableData] = useState([]);
  const [TabularTableData, setTabularTableData] = useState([]);
  const [documentTable, setDocumentTable] = useState("");
  const [tabularTable, setTabularTable] = useState("");
  const [openDocument, setOpenDocument] = useState(false);
  const [openTabular, setOpenTabular] = useState(false);

  const [reportName, setReportName] = useState("");
  const [tables, setTables] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  // const [successMessage, setSuccessMessage] = useState('');
  // const [errorMessage, setErrorMessage] = useState('');
  const [showAddTableModal, setShowAddTableModal] = useState(false);
  const [showModal, setShowModal] = useState(false); // Initially hidden
  const [tableIndex, setTableIndex] = useState("");
  const [columnIndex, setColumnIndex] = useState("");
  const [allTables, setAllTables] = useState([]);
  const [addfixedValues, setAddfixedValues] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [companyLocationId, setCompanyLocationId] = useState("");
  const [status, setStatus] = useState("");
  
  // Excel data states
  const [excelDataByTable, setExcelDataByTable] = useState({});
  const [showExcelOptionsModal, setShowExcelOptionsModal] = useState(false);
  const [pendingExcelData, setPendingExcelData] = useState(null);
  const [existingExcelData, setExistingExcelData] = useState({});
  
  // Tour-related states
  const [addTourPopUp, setAddTourPopUp] = useState(false);
  const [allTour, setAllTours] = useState([]);
  const [allTourLoading, setTourLoading] = useState(false);
  const [selectedTour, setSelectedTour] = useState("");
  const [savedTourValues, setTourValues] = useState([]);
  const [email, setEmail] = useState({
    to: [],
    cc: [],
    bcc: [],
  });
  const [exportConfig, setExportConfig] = useState({
    generateType: "",
    blackAndWhite: false,
    orientation: "portrait",
  });

  const { companyList } = useAppContext();

  // ----------------------------------------------------------------------------------
  const fetchReport = async () => {
    try {
      const response = await fetch(`${API_URL}/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `
          query GetSingleTemplate($getSingleTemplateId: ID!) {
            getSingleTemplate(id: $getSingleTemplateId) {
              success
              status
              message
              data
            }
          }
        `,
          variables: {
            getSingleTemplateId: reportTempId,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const { data, errors } = await response.json();

      // setReportName(data.name);
      // setTables(data.tables || []);
      // const filteredUser = users.find(
      //   (user) => data.companyName === user.company
      // );

      if (errors) {
        throw new Error(`GraphQL errors: ${JSON.stringify(errors)}`);
      }

      return data.getSingleTemplate; // Return the data if successful
    } catch (error) {
      console.error("Error fetching report:", error);
      throw error; // Re-throw the error for the caller to handle
    }
  };

  // const fetchCompanyAndLocation = async () => {
  //   const additionalDataRef = ref(database, `clientLocations`);
  //   const snapshot = await get(additionalDataRef);
  //   if (snapshot.exists()) {
  //     const additionalData = snapshot.val();
  //     let clientData = Object.keys(additionalData)
  //       .map((key) => ({
  //         id: key,
  //         ...additionalData[key],
  //       }))
  //       .filter((item) => !item.isDeleted && item.clientName);

  //     let uniqueClientNames = new Set();
  //     clientData.filter((item) => {
  //       if (uniqueClientNames.has(item.clientName)) {
  //         return false;
  //       } else {
  //         uniqueClientNames.add(item.clientName);
  //         return true;
  //       }
  //     });
  //     uniqueClientNames = Array.from(uniqueClientNames);
  //     const clientLocationsMap = {};

  //     clientData.forEach((item) => {
  //       if (!clientLocationsMap[item.clientName]) {
  //         clientLocationsMap[item.clientName] = [];
  //       }
  //       clientLocationsMap[item.clientName].push({
  //         ...item,
  //         formattedAddress: `${item.address}, ${item.city}, ${item.state} ${item.zipCode}`,
  //       });
  //     });
  //     const clientDataArray = Object.keys(clientLocationsMap).map(
  //       (clientName) => ({
  //         id: clientName,
  //         company: clientName,
  //         clientLocations: clientLocationsMap[clientName],
  //       })
  //     );
  //     setUsers(clientDataArray);
  //   }
  // };

  // useEffect(() => {
  //   fetchCompanyAndLocation();
  // }, []);

  const getReportData = async () => {
    try {
      const reportData = await fetchReport();
      const fetchedCompanyId = reportData?.data?.company?.id;

      console.log("reportDatareportData", reportData);
      console.log(
        "reportDatareportData companyId",
        fetchedCompanyId
      );

      const location = reportData?.data?.company;
      setStatus(reportData?.data?.report?.status);
      setReportName(reportData?.data?.report?.reportName);
      setTables(reportData?.data?.report?.tables || []);
      setCompanyId(fetchedCompanyId);
      setCompanyName(reportData?.data?.company?.company);
      setCompanyLocation(
        `${location.address}, ${location.city}, ${location?.state} ${location.zipCode}`
      );
      // Load email data if it exists
      if (reportData?.data?.report?.email) {
        setEmail(reportData.data.report.email);
      } else {
        setEmail({ to: [], cc: [], bcc: [] });
      }
      // Load exportConfig data if it exists
      if (reportData?.data?.report?.exportConfig) {
        setExportConfig(reportData.data.report.exportConfig);
      } else {
        setExportConfig({
          generateType: "",
          blackAndWhite: false,
          orientation: "portrait",
        });
      }

      // Fetch existing Excel data for all tables
      if (reportTempId && reportData?.data?.report?.tables) {
        try {
          const excelDataPromises = reportData.data.report.tables.map(table =>
            getExcelDataByReportAPI(reportTempId, table.id.toString())
          );
          
          const excelDataResults = await Promise.all(excelDataPromises);
          
          // Map Excel data by table ID
          const excelDataMap = {};
          reportData.data.report.tables.forEach((table, index) => {
            const tableExcelData = excelDataResults[index];
            if (tableExcelData && tableExcelData.length > 0) {
              // Use the most recent Excel data entry
              excelDataMap[table.id] = tableExcelData[0].data;
            }
          });
          
          setExistingExcelData(excelDataMap);
        } catch (error) {
          console.error("Error fetching Excel data:", error);
        }
      }
    } catch (error) {
      // Handle errors here
      console.error("Failed to get report:", error);
    }
  };

  useEffect(() => {
    getReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddTable = (type) => {
    setTables((prevTables) => [
      ...prevTables,
      {
        id: Date.now(),
        type: type,
        name: "",
        columns: [],
      },
    ]);
    setShowAddTableModal(false);
  };

  const handleDeleteTable = (tableIndex) => {
    const updatedTables = [...tables];
    updatedTables.splice(tableIndex, 1);
    setTables(updatedTables);
  };

  const handleTableNameChange = (tableIndex, value) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].tableName = value;
    setTables(updatedTables);
  };

  console.log("tables", tables);

  const handleAddColumn = (tableIndex) => {
    console.log("tableIndex:", tableIndex); // Debug log
    if (tableIndex !== undefined && tableIndex !== null) {
      const updatedTables = [...tables];
      console.log("Before adding column:", updatedTables[tableIndex]);
      if (!updatedTables[tableIndex].columns) {
        updatedTables[tableIndex].columns = [];
      }
      const newColumn = {};
      console.log("Table type:", updatedTables[tableIndex].type); // Debug log
      switch (updatedTables[tableIndex].type) {
        case "Document":
          Object.assign(newColumn, {
            sequence: "",
            title: "Title",
            height: "15",
            width: "10",
            format: "textarea",
            border: "No",
            mandatory: "false",
          });
          break;
        case "Tabular":
          Object.assign(newColumn, {
            sequence: "",
            title: "Title",
            height: "15",
            width: "10",
            format: "textarea",
            border: "No",
            mandatory: "false",
            fixed: [],
            type: "",
          });
          break;
        default:
          console.log("Unknown table type:", updatedTables[tableIndex].type); // Debug log
          return; // Do nothing if type is not recognized
      }

      updatedTables[tableIndex].columns.push(newColumn);
      console.log("After adding column:", updatedTables[tableIndex]); // Debug log
      setTables(updatedTables);
      console.log("Updated tables state:", tables); // Debug log after state update
    }
  };

  const handleExcelUpload = async (tableIndex) => {
    // Validate tableIndex and tables array
    if (tableIndex === undefined || tableIndex === null || !Array.isArray(tables) || tableIndex < 0 || tableIndex >= tables.length) {
      toast.error("Invalid table selection");
      return;
    }

    const table = tables[tableIndex];
    if (!table || !table.id) {
      toast.error("Table not found");
      return;
    }

    const input = window.document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx,.xls";
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) {
        // Clean up input element
        input.remove();
        return;
      }

      try {
        const reader = new FileReader();
        reader.onload = async (event) => {
          try {
            // Re-validate table exists (in case state changed during async operation)
            const currentTable = tables[tableIndex];
            if (!currentTable || !currentTable.id) {
              toast.error("Table no longer available");
              input.remove();
              return;
            }

            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            if (jsonData.length === 0) {
              toast.error("Excel file is empty");
              input.remove();
              return;
            }

            // Row 1 (index 0): Master indicators (or legacy: headers if only one row); Row 2 (index 1): column headers
            const firstRow = jsonData[0] || [];
            const headerRow = jsonData.length >= 2 ? (jsonData[1] || []) : firstRow;
            const headers = headerRow.map(h => h != null && h !== "" ? String(h).trim() : "").filter(Boolean);
            
            if (headers.length === 0) {
              toast.error("No headers found in Excel file (use row 2 for headers)");
              input.remove();
              return;
            }

            // Build masterEntries: column names from row 2 where row 1 cell is "Master" (only when we have 2+ rows)
            const masterEntries = [];
            if (jsonData.length >= 2) {
              for (let col = 0; col < headers.length; col++) {
                const cell = firstRow[col];
                const isMaster = cell != null && String(cell).trim().toLowerCase() === "master";
                if (isMaster && headers[col]) masterEntries.push(headers[col]);
              }
            }

            const tableColumns = currentTable.columns || [];
            const dataStartIndex = jsonData.length >= 2 ? 2 : 1;
            // Map ALL Excel columns so every header (Driver Name, Container Name, Name, Age, etc.) is saved
            const mappedData = {};
            headers.forEach((headerName, headerIndex) => {
              const columnValues = [];
              for (let i = dataStartIndex; i < jsonData.length; i++) {
                const value = jsonData[i][headerIndex];
                if (value !== null && value !== undefined && value !== "") {
                  columnValues.push(String(value));
                }
              }
              if (columnValues.length > 0) mappedData[headerName] = columnValues;
            });
            // Require at least one Excel column to match a table column
            const tableTitles = new Set((tableColumns || []).map((c) => (c?.title || "").toLowerCase().trim()).filter(Boolean));
            const matchedColumns = headers.filter((h) => h && tableTitles.has(h.toLowerCase().trim())).length;
            if (matchedColumns === 0) {
              toast.error("No matching columns found between Excel headers and table fields");
              input.remove();
              return;
            }

            const payload = { ...mappedData, masterEntries };

            // Check if there's existing data for this table
            const hasExistingData = existingExcelData[currentTable.id] || excelDataByTable[currentTable.id];
            
            if (hasExistingData) {
              setPendingExcelData({
                tableIndex,
                tableId: currentTable.id,
                data: payload,
                matchedColumns
              });
              setShowExcelOptionsModal(true);
            } else {
              setExcelDataByTable(prev => ({
                ...prev,
                [currentTable.id]: payload
              }));
              toast.success(`Excel data loaded for ${matchedColumns} column(s). Click "Save Report" to save.`, { autoClose: 4000 });
            }
            
            // Clean up input element
            input.remove();
          } catch (error) {
            console.error("Error processing Excel file:", error);
            toast.error("Failed to process Excel file");
            input.remove();
          }
        };
        
        reader.onerror = () => {
          toast.error("Failed to read file");
          input.remove();
        };
        
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error("Error reading file:", error);
        toast.error("Failed to read file");
        input.remove();
      }
    };
    
    input.click();
  };

  const handleExcelOptionSelect = (option) => {
    if (!pendingExcelData) {
      setShowExcelOptionsModal(false);
      return;
    }

    const { tableId, data, matchedColumns } = pendingExcelData;

    // Validate required fields
    if (!tableId || !data || typeof matchedColumns !== 'number') {
      toast.error("Invalid Excel data");
      setShowExcelOptionsModal(false);
      setPendingExcelData(null);
      return;
    }

    if (option === "refresh") {
      // Replace all data
      setExcelDataByTable(prev => ({
        ...prev,
        [tableId]: data
      }));
      toast.success(`Excel data refreshed for ${matchedColumns} column(s). Click "Save Report" to save.`, { autoClose: 4000 });
    } else if (option === "add") {
      // Merge with existing data (add new data on top); exclude masterEntries from column keys
      const existingRaw = excelDataByTable[tableId] || existingExcelData[tableId] || {};
      const existingData = existingRaw && existingRaw.data !== undefined ? existingRaw.data : existingRaw;
      const colKeys = (obj) => Object.keys(obj || {}).filter(k => k !== "masterEntries");
      const allColumns = new Set([...colKeys(existingData), ...colKeys(data)]);
      const mergedData = {};
      allColumns.forEach(columnName => {
        const newValues = (data && Array.isArray(data[columnName]) ? data[columnName] : []) || [];
        const oldValues = (existingData && Array.isArray(existingData[columnName]) ? existingData[columnName] : []) || [];
        mergedData[columnName] = [...newValues, ...oldValues];
      });
      const masterEntriesToKeep = (data && data.masterEntries) || (existingRaw && existingRaw.masterEntries) || [];
      setExcelDataByTable(prev => ({
        ...prev,
        [tableId]: { ...mergedData, masterEntries: masterEntriesToKeep }
      }));
      toast.success(`Excel data added for ${matchedColumns} column(s). Click "Save Report" to save.`, { autoClose: 4000 });
    }

    // Close modal and clear pending data
    setShowExcelOptionsModal(false);
    setPendingExcelData(null);
  };

  // add fixed value
  const handleAddfixedColumn = (tableIndex, columnIndex) => {
    const updatedTables = [...tables];

    // Check if the fixed array is initialized
    if (!updatedTables[tableIndex].columns[columnIndex].fixed) {
      updatedTables[tableIndex].columns[columnIndex].fixed = []; // Initialize the array if it's not
    }

    updatedTables[tableIndex].columns[columnIndex].fixed.push("");
    setTables(updatedTables);
  };

  // const handleChange = (tableIndex, columnIndex, fieldName, value) => {
  //   if (value === undefined) return;

  //   const updatedTables = [...tables];

  //   // Update the specific field with the new value
  //   updatedTables[tableIndex].columns[columnIndex][fieldName] = value;

  //   // If the field being changed is a fixed value, save the change
  //   if (fieldName === "fixed") {
  //     updatedTables[tableIndex].columns[columnIndex].fixed = value;
  //   }

  //   setTables(updatedTables);

  //   // If the format field is changed to "fixed value", show the modal to edit fixed values
  //   if (fieldName === "format" && value === "fixed value") {
  //     setTableIndex(tableIndex);
  //     setColumnIndex(columnIndex);
  //     setShowModal(true);
  //     setAddfixedValues(true);
  //   }
  // };
  const handleChange = (tableIndex, columnIndex, fieldName, value) => {
    if (value === undefined) return;

    const updatedTables = [...tables];
    const previousFormat = fieldName === "format" ? updatedTables[tableIndex].columns[columnIndex].format : null;

    // Convert width to string explicitly if needed, and strip % sign for storage
    let processedValue = value;
    if (fieldName === "width" || fieldName === "height") {
      // Remove % sign if present, then convert to string
      processedValue = String(value).replace('%', '');
    } else if (fieldName === "sequence") {
      processedValue = String(value);
    }
    
    updatedTables[tableIndex].columns[columnIndex][fieldName] = processedValue;

    // If format is changing away from "fixed value", reset fixed and close modal (fixed value data is not valid for qrcode/tour).
    if (fieldName === "format") {
      if (previousFormat === "fixed value" && value !== "fixed value") {
        setAddfixedValues(false);
        updatedTables[tableIndex].columns[columnIndex].fixed = [];
      }
      if (value === "fixed value") {
        // When entering "fixed value", reset fixed so new values can be added (prevents Tour/Qrcode data from leaking)
        if (previousFormat !== "fixed value") {
          updatedTables[tableIndex].columns[columnIndex].fixed = [];
        }
        setTableIndex(tableIndex);
        setColumnIndex(columnIndex);
        setShowModal(true);
        setAddfixedValues(true);
      }
    }

    // Handle tour selection
    if (fieldName === "format" && value === "tour") {
      setTableIndex(tableIndex);
      setColumnIndex(columnIndex);
      setAddTourPopUp(true);
      FetchAllTours();
    }

    // Handle checkpoint selection
    if (fieldName === "format" && value === "checkpoint") {
      const tourColumn = updatedTables[tableIndex].columns.find(
        (col) => col.type === "tour"
      );

      if (tourColumn && tourColumn.fixed) {
        const checkpointNames = tourColumn.fixed
          .map((checkpointString) => {
            try {
              const checkpoint = JSON.parse(checkpointString);
              return checkpoint.checkpointName;
            } catch (error) {
              console.error("Error parsing checkpoint JSON:", error);
              return null;
            }
          })
          .filter(Boolean);

        updatedTables[tableIndex].columns[columnIndex].fixed = checkpointNames;
      } else {
        toast.warn("Please add a tour to the table first.");
        updatedTables[tableIndex].columns[columnIndex].format = "";
      }
    }

    // Handle qrcode selection - use savedTourValues if available, otherwise preserve existing (like createreport)
    if (fieldName === "format" && value === "qrcode") {
      updatedTables[tableIndex].columns[columnIndex].type = "tour";
      if (savedTourValues && savedTourValues.length > 0) {
        updatedTables[tableIndex].columns[columnIndex].fixed = savedTourValues;
      }
    }

    setTables(updatedTables);
  };

  const handleChangefix = (tableIndex, columnIndex, value, fixedIndex) => {
    if (value === undefined) return; // Avoid updating with undefined value

    const updatedTables = [...tables];
    updatedTables[tableIndex].columns[columnIndex].fixed[fixedIndex] = value;
    setTables(updatedTables);
  };

  const handleDeleteRow = (tableIndex, columnIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].columns.splice(columnIndex, 1);
    setTables(updatedTables);
  };

  const handleDeleteFixedRow = (tableIndex, columnIndex, fixedIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].columns[columnIndex].fixed.splice(fixedIndex, 1);
    setTables(updatedTables);
  };

  // Tour-related functions
  const FetchAllTours = async () => {
    setTourLoading(true);
    try {
      const response = await GetAllTourAPI();
      const tourData = response || [];
      setAllTours(tourData);
    } catch (error) {
      console.error("Error fetching tours:", error);
    } finally {
      setTourLoading(false);
    }
  };

  const handleConfirmTour = async () => {
    if (!selectedTour) {
      toast.error("Please select a tour");
      return;
    }

    try {
      // Fetch checkpoints for the selected tour
      const tour = await GetTourByIdAPI(selectedTour);
      const checkpointNames = tour?.checkpoints?.map((checkpoint) => checkpoint.checkpointName) || [];
      const parseValue = tour?.checkpoints?.map((checkpoint) => JSON.stringify({ ...checkpoint, distance: tour?.distance })) || [];

      const updatedTables = [...tables];
      const columnFormat = updatedTables[tableIndex]?.columns[columnIndex]?.format;

      if (columnFormat === "qrcode") {
        // QR code columns need checkpoint JSON strings for preview
        updatedTables[tableIndex].columns[columnIndex].fixed = parseValue;
        updatedTables[tableIndex].columns[columnIndex].type = "tour";
      } else {
        // Tour columns need checkpoint names
        updatedTables[tableIndex].columns[columnIndex].fixed = checkpointNames;
        updatedTables[tableIndex].columns[columnIndex].type = "fixedValue";
      }
      updatedTables[tableIndex].columns[columnIndex].tourId = tour?.id;

      setTables(updatedTables);
      setTourValues(parseValue);
      setAddTourPopUp(false);
      setSelectedTour("");
    } catch (error) {
      toast.error("Failed to fetch checkpoints");
      console.error("Error in handleConfirmTour:", error);
    }
  };

  // Helper function to sort columns: Ref columns first, then others by sequence
  const sortColumns = (columns) => {
    return [...columns].sort((a, b) => {
      const aSequence = Number(a?.sequence) || 0;
      const bSequence = Number(b?.sequence) || 0;
      const aIsRef = a?.format === "ref";
      const bIsRef = b?.format === "ref";
      
      // If one is Ref and the other isn't, Ref comes first
      if (aIsRef && !bIsRef) return -1;
      if (!aIsRef && bIsRef) return 1;
      
      // If both are Ref or both are not Ref, sort by sequence
      return aSequence - bSequence;
    });
  };

  const handleUpdateReportTemplate = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_URL}/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `
          mutation UpdateTemplate($updateTemplateId: ID!, $status: String, $reportName: String, $companyId: String, $tables: [TableInput], $email: JSON, $exportConfig: JSON) {
            updateTemplate(id: $updateTemplateId, status: $status, reportName: $reportName, companyId: $companyId, tables: $tables, email: $email, exportConfig: $exportConfig) {
              success
              message
            }
          }
        `,
          variables: {
            updateTemplateId: reportTempId,
            status: status || "active",
            reportName: reportName,
            companyId:companyId|| null,
            email: email,
            exportConfig: exportConfig,
            tables: tables.map((table) => {
              // Sort columns: Ref first, then by sequence
              const sortedColumns = sortColumns(table.columns || []);
              return {
                id: table.id,
                type: table.type,
                tableName: table.tableName,
                columns: sortedColumns.map((column) => ({
                  sequence: String(column.sequence),
                  title: column.title,
                  height: String(column.height),
                  width: String(column.width),
                  format: column.format,
                  type: column.type,
                  border: column.border,
                  mandatory: column.mandatory,
                  fixed: column.fixed || [],
                  tourId: column.tourId || null,
                })),
              };
            }),
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const { data, errors } = await response.json();

      if (errors) {
        toast.error("Something went wrong");
        throw new Error(`GraphQL errors: ${JSON.stringify(errors)}`);
      }

      const updatedTemplate = data.updateTemplate;

      if (updatedTemplate) {
        // If template update was successful and there's Excel data, handle it
        if (Object.keys(excelDataByTable).length > 0) {
          const upsertPromises = [];
          
          // Upsert Excel data for each table that has data
          for (const [tableId, data] of Object.entries(excelDataByTable)) {
            // Use upsert which will update existing or create new
            upsertPromises.push(
              upsertExcelDataAPI(reportTempId, tableId, data)
            );
          }

          try {
            await Promise.all(upsertPromises);
            toast.success("Report template and Excel data updated successfully");
          } catch (excelError) {
            console.error("Error upserting Excel data:", excelError);
            toast.warn("Report template updated but some Excel data failed to save");
          }
        } else {
          toast.success("Report template updated successfully");
        }
        
        navigate("/viewreport");
      } else {
        throw new Error("No updated template data returned");
      }
    } catch (error) {
      console.error("Error updating report template:", error);
      toast.error(`Error updating report template: ${error.message}`);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // ----------------------------------------------------------------------------------

  // Document Table
  const CreateDocumentTable = () => {
    setOpenDocument(true);
    setChooseTable(false);
    handleAddTable("Document");
    // setDocumentTable((prev) => ({
    //   ...prev,
    //   tableName: docTableName,
    //   type: "document",
    //   documentTableData,
    // }));
  };
  const DeleteDocumentTable = () => {
    setDocumentTableData([]);
    setDocumentTable("");
    setOpenDocument(false);
  };

  // Tabular Table
  const CreateTabularTable = () => {
    handleAddTable("Tabular");
    setOpenTabular(true);
    setChooseTable(false);
    setTabularTable((prev) => ({
      ...prev,
      tableName: TabuTableName,
      type: "Tabular",
      documentTableData,
    }));
  };
  const DeleteTabluarTable = () => {
    setTabularTableData([]);
    setTabularTable("");
    setOpenTabular(false);
  };

  console.log("documentTable", documentTable);

  useEffect(() => {
    setDocumentTable((prev) => ({ ...prev }));
  }, [documentTableData]);

  const [reportData, setReportData] = useState({
    reportName: "",
    companyName: "",
    companyLocation: "",
  });

  const ReportFormDataHandler = (e) => {
    const { name, value } = e.target;
    setReportData((prevReport) => ({
      ...prevReport,
      [name]: value,
    }));
  };

  // all table and all the data add on this
  const ReportDataHandler = () => {};

  const generateNewID = uuidv4();
  const randomID = generateNewID.slice(0, 8);

  const payload = {
    id: randomID,
    sequence: "",
    title: "",
    height: "",
    width: "50%",
    format: "text",
    border: "no",
    mandatory: "false",
  };

  const AddDocumentTableHandler = () => {
    const newEntry = { ...payload };

    setDocumentTableData((prevData) => [...prevData, newEntry]);
  };
  const AddTablularTableHandler = () => {
    const newEntry = { ...payload };
    setTabularTableData((prevData) => [...prevData, newEntry]);
  };

  // fixed Value
  const fixedPayload = {
    id: randomID,
    value: "",
  };

  const [fixedValues, setFixedValues] = useState("");

  const FixedInputHandler = (e, id) => {
    const { name, value } = e.target;
    const updatedDocumentTableData = fixedValues.map((item) =>
      item?.id === id ? { ...item, [name]: value } : item
    );
    setFixedValues(updatedDocumentTableData);
  };

  const DeleteFixedValueHandler = (id) => {
    console.log("id", id);
    const updated = fixedValues.filter((item) => item.id !== id);
    setFixedValues(updated);
  };

  // --------------------------------------------

  const DeleteHandler = (id) => {
    console.log("id", id);
    const updated = documentTableData.filter((item) => item.id !== id);
    setDocumentTableData(updated);
  };

  const [openTabularPreview, setopenTabularPreview] = useState(false);
  const [openDocumentPreview, setopenDocumentPreview] = useState(false);

  const documentInputHandler = (e, id) => {
    const { name, value } = e.target;
    const updatedDocumentTableData = documentTableData.map((item) =>
      item?.id === id ? { ...item, [name]: value } : item
    );
    setDocumentTableData(updatedDocumentTableData);
  };
  const TabularInputHandler = (e, id) => {
    const { name, value } = e.target;
    const updatedDocumentTableData = TabularTableData.map((item) =>
      item?.id === id ? { ...item, [name]: value } : item
    );
    if (name === "format" && value === "fixed value") {
      setAddfixedValues(true);
    }

    setTabularTableData(updatedDocumentTableData);
  };

  // console log
  console.log();

  useEffect(() => {
    // console.log("documentTableData", documentTableData);
    console.log("fixedValues", fixedValues);
  }, [documentTableData, TabularTableData, fixedValues]);

  // ---------------------------------
  const [successMessage, setSuccessMessage] = useState("");

  const [previewTableIds, setPreviewTableIds] = useState([]);

  const PreviewHandler = (tableId) => {
    const have = previewTableIds.includes(tableId);
    if (have) {
      const filter = previewTableIds.filter((table) => table !== tableId);
      setPreviewTableIds(filter);
    } else {
      setPreviewTableIds([...previewTableIds, tableId]);
    }
    // console.warn(have);
  };

  // console.log("previewTableIds", previewTableIds);
  useEffect(() => {
    if (companyName) {
      const find = users.find((item) => item.company === companyName);
      console.log("find", find);
    }
  }, [companyName]);

  console.log("tables", tables);
  console.warn("previewTableIds", previewTableIds);

  // ----------------------------STATUS UPDATE---------------------------------------

  const StatusBtn = ({ title, onClick }) => (
    <button
      onClick={onClick}
      className={`border mr-4 tracking-wider capitalize  ${
        status === "active"
          ? "border-green-700 text-green-700"
          : status === "inactive"
          ? "border-red-700 text-red-700"
          : "border-yellow-600 text-yellow-600"
      }
       p-2 px-8 rounded-md flex items-center gap-1 font-semibold text-nowrap`}
    >
      {title ? title : "Loading Status"}
    </button>
  );

  const StatusUpdateHandler = () => {
    setStatus(status === "active" ? "inactive" : "active");
  };
  // console.log("USERS ", users);
  // console.log("Report TEMPLATE ", reportTemplates);
  // console.log("clientLocations ");
  // console.log("COMPANTASDASD", companyId);
  return (
    <>
      {/* Tour Selection Modal */}
      <Modal
        isOpen={addTourPopUp}
        onClose={() => setAddTourPopUp(false)}
        title="Choose tour"
        size="md"
        showCloseButton={true}
      >
        <div className="space-y-4">
          <select
            className="w-full shadow p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setSelectedTour(e.target.value)}
            value={selectedTour}
          >
            <option value="">Choose the tour</option>
            {allTour && Array.isArray(allTour) && allTour.length > 0 ? (
              allTour
                .filter((item) => String(item?.companyId) === String(companyId))
                .map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.tourName}
                  </option>
                ))
            ) : (
              <option disabled>No tours available</option>
            )}
          </select>
          {!companyId && (
            <div className="text-red-500 text-xs">Choose company first</div>
          )}
          {allTour && Array.isArray(allTour) && allTour.filter((item) => String(item?.companyId) === String(companyId)).length === 0 && companyId && (
            <div className="text-orange-500 text-xs">No tours found for this company</div>
          )}
          {companyId && (
            <div className="flex justify-center">
              <button
                className="text-white bg-blue-500 text-sm p-2 px-4 rounded-md hover:bg-blue-600 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleConfirmTour}
                disabled={!selectedTour}
              >
                {allTourLoading ? "Loading..." : "Confirm"}
              </button>
            </div>
          )}
        </div>
      </Modal>

      {/* Excel Upload Options Modal */}
      <Modal
        isOpen={showExcelOptionsModal}
        onClose={() => {
          setShowExcelOptionsModal(false);
          setPendingExcelData(null);
        }}
        title="Excel Data Upload Options"
        size="md"
        showCloseButton={true}
      >
        <div className="space-y-4">
          <p className="text-gray-700">
            This table already has Excel data. How would you like to proceed?
          </p>
          <div className="flex flex-col gap-3">
            <button
              className="w-full py-3 px-6 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
              onClick={() => handleExcelOptionSelect("add")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
              Add More Data
              <span className="text-xs opacity-80">(New data on top of existing)</span>
            </button>
            <button
              className="w-full py-3 px-6 rounded-lg bg-orange-600 text-white font-semibold hover:bg-orange-700 transition-colors flex items-center justify-center gap-2"
              onClick={() => handleExcelOptionSelect("refresh")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
              </svg>
              Refresh Data
              <span className="text-xs opacity-80">(Replace all existing data)</span>
            </button>
          </div>
        </div>
      </Modal>

      <div
        className={`flex flex-col gap-2 h-full   text-sm createReportScroll pb-20 ${PixelStyle}`}
      >
        <HeaderContainer
          pageTitle="Customize Report"
          container={<StatusBtn title={status} onClick={StatusUpdateHandler} />  } isRedirecting={false}
        >
          <NavLink to="/viewreport" className="hover:text-black" isRedirecting={false}>
            View report
          </NavLink>
          <span className="">/</span>
          <span className="text-black">Customize report</span>
        </HeaderContainer>

        <div className="w-full flex gap-3">
          <div
            className={`w-full flex justify-between gap-10 bg-white shadow p-3 rounded-lg border ${
              status === "inactive" ? "border-red-500" : ""
            } `}
          >
            <div className="flex gap-3 w-full">
              <input
                placeholder="Report Name"
                className="border border-zinc-200 p-2 rounded-md w-full"
                // onChange={ReportFormDataHandler}
                value={reportName}
                onChange={(e) => setReportName(e.target.value)}
                name="reportName"
              />

              <SearchableDropdown
                users={companyList}
                selectedCompany={companyName}
                setCompanyId={setCompanyId}
                onSelect={setCompanyName}
                setCompanyLocationId={setCompanyLocationId}
                setCompanyLocation={setCompanyLocation}
                // setCompanyName=set
              />

              <div className="border border-zinc-200 p-2 rounded-md w-full text-nowrap overflow-x-auto min-w-40  scrollHeight">
                {companyLocation ? (
                  companyLocation
                ) : (
                  <span className="text-zinc-400">Location </span>
                )}
              </div>
            </div>
            <div>
              <button
                onClick={() => setChooseTable(!chooseTable)}
                className={`border  ${
                  chooseTable
                    ? "border-red-500 text-red-500"
                    : "border-blue-500 text-blue-600"
                } p-2 px-5 rounded-md flex items-center gap-1  font-semibold text-nowrap`}
              >
                <MdOutlineAdd
                  className={`text-xl transition duration-300  ${
                    chooseTable && "rotate-45"
                  } `}
                />
                {chooseTable ? "Close" : "Add data"}
              </button>
            </div>
          </div>
          <div
            className={`bg-white border shadow p-3 rounded-lg text-nowrap flex items-center  ${
              status === "inactive" ? "border-red-500" : ""
            }`}
          >
            <button
              className=" p-2 px-5 rounded-md hover:bg-red-500 border hover:text-white "
              onClick={() => navigate("/viewreport")}
            >
              Cancel
            </button>
          </div>
          <div
            className={`bg-white border shadow p-3 rounded-lg text-nowrap flex items-center  ${
              status === "inactive" ? "border-red-500" : ""
            }`}
          >
            <button
              className=" p-2 px-5 rounded-md bg-blue-500 text-white "
              onClick={handleUpdateReportTemplate}
            >
              Save Report
            </button>
          </div>
        </div>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 ">
          <div className="transform transition-all duration-300 ">
            <EmailSection email={email} onChange={setEmail} />
          </div>
          <div className="transform transition-all duration-300 ">
            <ExportConfig exportConfig={exportConfig} onChange={setExportConfig} />
          </div>
        </div>

        <div className="flex flex-col gap-5 items-center justify-start my-5 pb-20 relative  ">
          {chooseTable && (
            <div className="fixed inset-0 z-50 flex backdrop-blur-sm  items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-xl shadow-2xl drop-shadow-2xl p-6 w-96">
                <div className="flex justify-between items-center mb-2">
                  <h1 className="text-base  w-full text-center font-bold text-black">
                    Select Data Type
                  </h1>
                  <button 
                    onClick={() => setChooseTable(false)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    ×
                  </button>
                </div>
                <div className="border-t border-gray-200 mb-6"></div>
                <div className="flex gap-4">
                  <button
                    onClick={() => {
                      CreateDocumentTable();
                    }}
                    className="flex-1 py-3 bg-blue-600 text-white px-6 rounded-lg font-semibold transition-colors"
                  >
                    Fields
                  </button>
                  <button
                    onClick={() => {
                      CreateTabularTable();
                    }}
                    className="flex-1 py-3 bg-blue-600 text-white px-6 rounded-lg font-semibold transition-colors"
                  >
                    Table
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="w-full mb-10 ">
            {tables.map((table, tableIndex) => (
              <>
                {table.type === "Document" && (
                  <div className={`flex flex-col gap-3 w-full my-5 `}>
                    <div className="bg-white  shadow rounded-md overflow-hidden ">
                      <div className="bg-[#00325d] text-white w-full text-xs text-green-700 py-0.5 font-semibold px-4 ">
                        Fields
                      </div>
                      <div className="p-4 w-full flex flex-col gap-5">
                        <div className="flex justify-between">
                          <div className="flex flex-col items-start">
                            <input
                              placeholder="Field Name"
                              value={table?.tableName}
                              // onChange={(e) => setDocTableName(e.target.value)}
                              onChange={(e) =>
                                handleTableNameChange(
                                  tableIndex,
                                  e.target.value
                                )
                              }
                              className="bg-transparent outline-none text-2xl font-bold mb-1 text-zinc-600"
                            />
                            {docTableName === "table 1" && (
                              <span className="border-[#00325d] border rounded-full px-5 text-xs text-[#00325d]">
                                Editable
                              </span>
                            )}
                          </div>
                          <div className="flex items-center gap-3 ">
                            <button
                              className={`flex items-center gap-2 border p-1.5 px-4 rounded-md ${
                                previewTableIds.includes(table.id) &&
                                " border-[#00325d]"
                              } `}
                              onClick={() => PreviewHandler(table.id)}
                            >
                              {previewTableIds.includes(table.id) ? (
                                <LuEye />
                              ) : (
                                <LuEyeOff />
                              )}
                              <span className="text-xs"> Preview</span>
                            </button>

                            <button
                              onClick={() => handleDeleteTable(tableIndex)}
                              className={` text-zinc-600 hover:text-red-400 border border-zinc-200 hover:border-red-200  p-1.5 rounded-lg ${
                                docTableName === "table 1" && "px-4 text-xl"
                              }`}
                            >
                              <RiDeleteBin6Line />
                            </button>
                          </div>
                        </div>
                        <div class="relative overflow-x-auto pb-8 ">
                          <table class="w-full text-sm text-left rtl:text-right ">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
                              <tr>
                                <th scope="col" class="px-6 py-3">
                                  Sequence
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Title
                                </th>
                                {/* <th scope='col' class='px-6 py-3'>
                          Height (px)
                        </th> */}
                                <th scope="col" class="px-6 py-3">
                                  Width (%)
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Specific Format
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Border
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Mandatory
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  <button
                                    // onClick={AddDocumentTableHandler}
                                    onClick={() => handleAddColumn(tableIndex)}
                                    className="p-1 px-2 border-2  border-green-400 text-green-500 rounded-lg flex items-center gap-1"
                                  >
                                    <MdOutlineAdd className="text-lg" />
                                    <span className="">ADD</span>
                                  </button>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {table?.columns &&
                                table?.columns.map((column, columnIndex) => (
                                  <tr class="bg-white border-b  ">
                                    <th
                                      scope="row"
                                      class="px-5 py-4 font-medium text-black whitespace-nowrap "
                                    >
                                      <Input
                                        placeholder="Sequence"
                                        className="w-20"
                                        value={column?.sequence}
                                        onChange={(e) =>
                                          handleChange(
                                            tableIndex,
                                            columnIndex,
                                            "sequence",
                                            e.target.value
                                          )
                                        }
                                        name="sequence"
                                      />
                                    </th>
                                    <td class="px-5 py-4">
                                      <Input
                                        placeholder="Title"
                                        value={column.title}
                                        onChange={(e) =>
                                          handleChange(
                                            tableIndex,
                                            columnIndex,
                                            "title",
                                            e.target.value
                                          )
                                        }
                                        name="title"
                                      />
                                    </td>
                                    {/* <td class='px-5 py-4'>
                            <Input
                              placeholder='Height'
                              onChange={(e) =>
                                documentInputHandler(e, column?.id)
                              }
                              name='height'
                            />
                          </td> */}
                                    <td class="px-5 py-4">
                                      {/* <Input
                                      className='w-20'
                                      placeholder='width'
                                      value={column.width}
                                      onChange={(e) =>
                                        e.target.value <= 100 &&
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "width",
                                          e.target.value
                                        )
                                      }
                                      name='width'
                                    /> */}

                                      <select
                                        className="px-2 border p-2 rounded-md"
                                        value={column.width ? `${column.width}%` : "50%"}
                                        onChange={(e) =>
                                          handleChange(
                                            tableIndex,
                                            columnIndex,
                                            "width",
                                            e.target.value
                                          )
                                        }
                                        name="width"
                                      >
                                        <option>50%</option>
                                        <option>100%</option>
                                      </select>
                                    </td>
                                    <td class="px-5 py-4">
                                      {/* <Input placeholder='Format ' /> */}
                                      <select
                                        className="px-2 border p-2 rounded-md"
                                        value={column.format}
                                        onChange={(e) =>
                                          handleChange(
                                            tableIndex,
                                            columnIndex,
                                            "format",
                                            e.target.value
                                          )
                                        }
                                        name="format"
                                      >
                                        {/* <option value="input">Text</option> */}
                                      <option value="number">Number</option>
                                      <option value="date">Date</option>
                                      {/* <option value="time">Time</option> */}
                                      <option value="textarea">
                                        Text
                                      </option>
                                      <option value="Yes/No">Yes/No</option>
                                      <option value="photo Upload">
                                        Photo Upload
                                      </option>
                                      <option value="photo Capture">
                                        Photo Capture
                                      </option>
                                      <option value="f&c">F&C</option>
                                      <option value={"time am/pm"}>
                                        Time - AM/PM
                                      </option>
                                      <option value={"time military"}>
                                        Time - Military
                                      </option>
                                      <option value={"checkbox"}>
                                        Checkbox
                                      </option>
                                      <option value={"e-sign"}>E-sign</option>
                                        {/* <option value={"tour"}>Tour</option>
                                        <option value={"checkpoint"}>Checkpoint</option>
                                        <option value={"qrcode"}>QR Code</option> */}
                                      </select>
                                    </td>
                                    <td class="px-6 py-4">
                                      <select
                                        className="px-2 border p-2 rounded-md "
                                        value={column.border}
                                        onChange={(e) =>
                                          handleChange(
                                            tableIndex,
                                            columnIndex,
                                            "border",
                                            e.target.value
                                          )
                                        }
                                        name="border"
                                      >
                                        <option>no</option>
                                        <option>yes</option>
                                      </select>
                                    </td>
                                    <td class="px-6 py-4">
                                      <select
                                        className="px-2 border p-2 rounded-md "
                                        value={column.mandatory}
                                        onChange={(e) =>
                                          handleChange(
                                            tableIndex,
                                            columnIndex,
                                            "mandatory",
                                            e.target.value
                                          )
                                        }
                                        name="mandatory"
                                      >
                                        <option value={"false"}>no</option>
                                        <option value={"true"}>yes</option>
                                      </select>
                                    </td>
                                    <td className="">
                                      <div className="flex justify-center items-center">
                                        {/* {item?.id} */}
                                        <RiDeleteBin6Line
                                          className="text-xl text-red-500 cursor-pointer"
                                          onClick={() =>
                                            handleDeleteRow(
                                              tableIndex,
                                              columnIndex
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {/* document preview section */}
                    {previewTableIds.includes(table.id) && (
                      <div className=" bg-white shadow rounded-md overflow-hidden">
                        <div className="bg-[#00325d] text-white w-full text-xs text-green-700 py-0.5 font-semibold px-4 ">
                          Preview
                        </div>
                        <div className="p-2">
                          <div className="">
                            {(table?.tableName || table?.name) && (
                              <p className="font-semibold mb-3 px-2 border-b pb-1">
                                {table?.tableName || table?.name}
                              </p>
                            )}
                            <div className=" grid grid-cols-1 md:grid-cols-2">
                              {Array.from({
                                length: Math.max(
                                  ...table.columns.map((item) => item.sequence)
                                ),
                              }).map((_, i) => {
                                const item = table.columns.find(
                                  (column) => Number(column.sequence) === i + 1
                                );

                                return (
                                  <div key={i} className="p-2">
                                    <div key={i + 1}>
                                      {item ? (
                                        <div className="p-2 grid grid-cols-2 items-start gap-1">
                                          <span className="font-semibold  bg-[#00325d] text-white border border-[#00325d] px-2 p-1">
                                            {item.title
                                              ? item.title
                                              : "Empty Title"}
                                          </span>
                                          <span
                                            className={`p-1 ${
                                              item.width === "100" ||
                                              item.width === "100%"
                                                ? "col-span-2 row-start-2"
                                                : "col-span-1"
                                            }`}
                                            style={
                                              item.border === "yes"
                                                ? { borderWidth: "1px" }
                                                : {}
                                            }
                                          >
                                            {item.format}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className=" bg-zinc-100 rounded-md py-2 "></div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {table.type === "Tabular" && (
                  <>
                    <TabularTableComponent
                      table={table}
                      tableIndex={tableIndex}
                      handleTableNameChange={handleTableNameChange}
                      handleChange={handleChange}
                      handleAddColumn={handleAddColumn}
                      handleDeleteTable={handleDeleteTable}
                      handleDeleteRow={handleDeleteRow}
                      PreviewHandler={PreviewHandler}
                      previewTableIds={previewTableIds}
                      UploadHandler={handleExcelUpload}
                      hasExcelData={!!excelDataByTable[table.id] || !!existingExcelData[table.id]}
                    />
                    {previewTableIds.includes(table.id) && (
                      <TabularTablePreview table={table} />
                    )}
                  </>
                )}
              </>
            ))}
          </div>

          {addfixedValues && (
            <div className="   flex items-center justify-center  absolute  top-0 backdrop-blur-sm z-10 h-full  w-full  ">
              <div className="bg-white rounded-lg p-4 shadow-lg w-1/2">
                <div className="flex justify-between items-center">
                  <div className=" text-zinc-600 font-semibold">
                    Fixed Value
                  </div>
                  <button
                    onClick={() =>
                      handleAddfixedColumn(tableIndex, columnIndex)
                    }
                    className="p-1 px-2 border-2 text-sm  border-green-400 text-green-500 rounded-lg flex items-center gap-1"
                  >
                    <MdOutlineAdd className="text-lg" />
                    <span className="">ADD</span>
                  </button>
                </div>
                <div>
                  <table class="w-full text-sm   text-gray-500 my-4  ">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
                      <tr>
                        <th scope="col" class="px-6 py-3 w-full">
                          value
                        </th>
                        <th scope="col" class="px-6 py-3">
                          remove
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tables[tableIndex]?.columns[columnIndex]?.fixed?.map(
                        (fix, fixedIndex) => {
                          return (
                            <tr key={fixedIndex} class="bg-white border-b  ">
                              <td class="px-5 py-4 font-medium text-black whitespace-nowrap ">
                                <Input
                                  placeholder="Sequence"
                                  className="w-full"
                                  value={fix} //fix.item
                                  onChange={(e) =>
                                    handleChangefix(
                                      tableIndex,
                                      columnIndex,
                                      e.target.value,
                                      fixedIndex
                                    )
                                  }
                                  name="value"
                                />
                              </td>
                              <td className="">
                                <div className="flex justify-center items-center">
                                  {/* {item?.id} */}
                                  <RiDeleteBin6Line
                                    className="text-xl text-red-500 cursor-pointer"
                                    onClick={() =>
                                      handleDeleteFixedRow(
                                        tableIndex,
                                        columnIndex,
                                        fixedIndex
                                      )
                                    }
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                  {/* {fixedValues ? (
                    fixedValues.length > 0 && ( */}
                  <button
                    onClick={() => setAddfixedValues(false)}
                    className="bg-blue-100 w-full p-2 rounded-md mt-2 border border-blue-300 text-blue-600 font-semibold"
                  >
                    Done
                  </button>
                  {/* ) */}
                  {/* ) : ( */}
                  <button
                    onClick={() => setAddfixedValues(false)}
                    className="bg-red-100 w-full p-2 rounded-md mt-2 border border-red-300 text-red-600 font-semibold"
                  >
                    Close
                  </button>
                  {/* )} */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportCustomize;

const Input = ({ placeholder, className, ...props }) => {
  return (
    <input
      placeholder={placeholder}
      className={`border border-zinc-200 outline-blue-500 p-2 rounded-md ${className}`}
      {...props}
    />
  );
};
